import React, { useState } from 'react';
import axios from 'axios';

import { FaDownload, FaUpload, FaTrash,  } from 'react-icons/fa';
import APIEndPoints from '../../../middleware/APIEndPoints';


const MyCV = () => {

    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (e) => {
      setSelectedFile(e.target.files[0]);
    };

    const getUploadCVURL = APIEndPoints.uploadCV.url;
    const getDeleteCVURL = APIEndPoints.uploadCV.url;
  
    const handleUpload = async () => {
      if (!selectedFile) {
        alert("Please select a file to upload.");
        return;
      }
  
      const formData = new FormData();
      formData.append('cv', selectedFile);
  
      try {
        await axios.post(getUploadCVURL, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        alert("File uploaded successfully.");
      } catch (err) {
        console.error("Upload error:", err);
        alert("File upload failed.");
      }
    };
  
    const handleDelete = async () => {
      try {
        await axios.delete(getDeleteCVURL);
        alert("File deleted successfully.");
      } catch (err) {
        console.error("Delete error:", err);
        alert("File deletion failed.");
      }
    };
  
  return (
    <div className='bg-[#1d0c39] h-screen pt-4'>
      <div className='flex justify-center items-center flex-col space-y-4'>

        <input type="file" onChange={handleFileChange} />
        <button onClick={handleUpload}>
          <FaUpload /> Upload CV
        </button>
        <button onClick={handleDelete}>
          <FaTrash /> Delete CV
        </button>
        <a href="http://localhost:8800/api/files/download-cv" className='bg-white text-black'>
          <FaDownload /> Download CV
        </a>
      </div>
    </div>
  )
}

export default MyCV
